<template>
  <div style="width: 94% !important; margin-left: 3% !important">
    <v-card-text
      class="common-textarea pa-0"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="pa-0"
        cols="6"
        style="
          font-weight: bold !important;
          display: inline-table !important;
          vertical-align: top !important;
          margin-top: 10px !important;
        "
        >{{ labelName }}
      </v-col>
      <v-col class="pa-0" style="display: inline-table !important" cols="6">
        <v-textarea
          type="string"
          auto-grow
          v-model="commonTextArea"
          :label="itemMessage"
          :disabled="!isClickable"
          :counter="maxCounterValue"
          :rules="!notRequired ? [(v) => !!v || itemMessage] : rules"
          :required="!notRequired"
          @change="handleTextInput"
        ></v-textarea>
      </v-col>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    notRequired: Boolean,
    isSmallDevice: Boolean,
    counterValue: Number,
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      commonTextArea: "",
    };
  },
  methods: {
    handleTextInput() {
      if(this.counterValue && this.commonTextArea.length > this.counterValue) {
        this.$emit("is-valid-input", false);
      } else if (this.commonTextArea !== "" && this.commonTextArea !== null) {
        this.$emit("set-text-area-value", this.commonTextArea);
        this.$emit("is-valid-input", true);
      } else {
        this.$emit("is-valid-input", true);
      }
    },
  },
  computed: {
    maxCounterValue() {
      return this.counterValue;
    }
  }
});
</script>

<style lang="css" scoped>
.common-textarea >>> .v-label {
  right: 0px !important;
  left: auto !important;
  font-size: 0.85rem;
  max-width: 100% !important;
  color: #9e9e9e;
}
.common-textarea >>> .v-icon {
  font-size: 1.25rem !important;
}
.common-textarea >>> .v-input {
  font-size: 0.85rem !important;
}
.common-textarea >>> .v-text-field {
  padding-top: 0 !important;
}
.common-textarea >>> .v-text-field input {
  font-size: 0.85rem;
  text-align: right;
}
.common-textarea >>> textarea {
  font-size: 0.85rem;
  text-align: right;
  height: 50px !important;
  overflow-y: auto;
}
.common-textarea >>> .v-input__slot:before {
  border-style: none !important;
}
.common-textarea >>> .v-messages__message {
  font-size: 0.85rem;
  text-align: left;
  float: right;
  margin-right: 0 !important;
}
.common-textarea >>> .v-input__slot:after {
  border-style: none !important;
}
.common-textarea >>> .v-text-field .v-label--active {
  display: none !important;
}

.common-textarea.small-device >>> * {
  font-size: 0.8rem !important;
}
</style>
